/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface UserDocumentsInfo {
    /**
     * The nationality of which the user possess documents
     */
    'nationality': string;
    /**
     * The user\'s profile fiscal code
     */
    'fiscalCode'?: string;
    /**
     * The user\'s profile VAT number
     */
    'vatNumber'?: string;
    /**
     * Type of document (ID card, driving license, or passport)
     */
    'documentType': UserDocumentsInfoDocumentTypeEnum;
    /**
     * The document number
     */
    'documentNumber': string;
    /**
     * Expiration Date of the document
     */
    'documentExpirationDate'?: string;
}

export const UserDocumentsInfoDocumentTypeEnum = {
    IdCard: 'IDCard',
    DrivingLicense: 'DrivingLicense',
    Passport: 'Passport',
} as const;

export type UserDocumentsInfoDocumentTypeEnum = typeof UserDocumentsInfoDocumentTypeEnum[keyof typeof UserDocumentsInfoDocumentTypeEnum];


